import Vue from 'vue'
import store from '../store'
import appRuntime from './webAppRuntime'
import jsActions from './jsActions'
import appEventHandlers from './appEventHandlers'
import auth from '@it-enterprise/jwtauthentication/dist/jwtauthentication.umd.min.js'
import worker from '@it-enterprise/digital-signature/dist/euscp.worker.js'
import router from '../router'
import { GraphqQlApi as api, getClient } from '@/api/api.js'
import InitWebAppCommon from './webAppCommon'
import InitDataSources from '../app-model/datasources'
import { i18n } from './i18n' 
import { notificationApi }  from '@/api/notificationApi'
import gql from 'graphql-tag'
import axios from './axios'
import appVersionsManager from './appVersionsManager'
import { setCurrentApplicationName } from '@/tools/'
import LZString from 'lz-string'
import vuetify from '@/plugins/vuetify'
let appConfig = store.state.general.config || await store.getters.getConfig
let wsUrl = appConfig.WsUrl

let appToDownloadObj = getAppToDownload()

let appName = appToDownloadObj.appName
let isSystem = appToDownloadObj.isSystem
let basePath = appToDownloadObj.basePath

const getModel = async function(appName, isSystem) {
  try {
    const skipCompressModel = typeof appConfig.skipCompressModel === 'boolean' ? appConfig.skipCompressModel : appConfig.skipCompressModel === 'true'
    const useModelCache = typeof appConfig.useModelCache === 'boolean' ? appConfig.useModelCache : appConfig.useModelCache === 'true'
    const response = await api.getModelFromGqlAsync(appName, isSystem, skipCompressModel, useModelCache)
    let object = response.data.webAppModelerQuery.modelByAppName
    let model = JSON.parse(object.model.startsWith('{') ? object.model : LZString.decompressFromUTF16(object.model))

    loadManifest(object.name)

    model['$ID'] = object.id
    model['Name'] = object.name
    model['SiteCaption'] = object.siteCaption
    model['UserModel'] = {}
    if (object.userModel) {
      model['UserModel'] = JSON.parse(object.userModel)
    }
    return { model }
  } catch (error) {
    console.error(error)
  }
  return { model: null }
}

const getLang = function () {
  return i18n.locale
}

export const initAuth = function({ oidcEnabled }) {
  auth.config(
    { 
      baseUrl: appConfig.GraphQlUrl,
      webUrl: `${window.location.origin}${process.env.VUE_APP_BASE_PATH}`, 
      oidc: oidcEnabled ? appConfig.oidc : null,
      onError: e => {
        switch (true) {
          case e.response && e.response.status === 400:
            auth.clearTokens()
            Vue.$routerCore.GoToSignIn()
            break
          case e.response && e.response.status <= 500:
          
            throw new Error(e)
          
          default: 
        }
      },
      getLang,
      closeSessionAutomatically: typeof appConfig.closeSessionAutomatically === 'boolean' ? appConfig.closeSessionAutomatically : appConfig.closeSessionAutomatically === 'true',
      afterSignOutAction: () => {
        store.commit('SET_USER', null)
        Vue.$routerCore.GoToSignIn()
      },
      fingerprint: appConfig.fingerprint || '',
      silentRequestTimeoutInSeconds: 2,
      useCookieForTokens: typeof appConfig.useCookieForTokens === 'boolean' ? appConfig.useCookieForTokens : appConfig.useCookieForTokens === 'true',
      needLockRefreshToken: true,
      useServerRememberMe: typeof appConfig.useServerRememberMe === 'boolean' ? appConfig.useServerRememberMe : appConfig.useServerRememberMe === 'true'
    }
  )
  if (appConfig.useOneSession) {
    setInterval(async () => {
      const response = await axios.post(new URL('api/authentication/pingsessionavailable',
        store.state.general.config.GraphQlUrl),
        undefined,
        {
          withCredentials: true,
          validateStatus: function (status) { return status <= 400 },
          isService: true
        })
      if (response && response.status == 400) {
        await auth.logout({
          returnUrl: window.location.pathname,
          skipSigninSilent: oidcEnabled,
          lang: i18n.locale
        }).then(() => {
          store.commit('SET_USER', null)
          Vue.$routerCore.GoToSignIn()
        })
      }
    }, 60000) // 1 minute
  }
}

const registerAppRuntime = async function() {
  // const { model, appVersion } = await getModel(appName, isSystem)
  const { model } = await getModel(appName, isSystem)
  if (!model) {
    store.commit('SET_APPLICATION_NOT_FOUND_STATUS', true)
    return
  }
  // сохранить имя приложения в глобальную переменную
  setCurrentApplicationName(appName)

  let dependencies = {
    i18n,
    axios,
    store,
    router
  }

  const oidcEnabled = !!model.ProjectSecurity.OidcEnabled
  initAuth({ oidcEnabled })
  localStorage.setItem('oidcEnabled', oidcEnabled)
  await Init(Vue, appRuntime, store, auth, router, model)
  InitWebAppCommon(Vue, {
    formioOptions: {
      auth,
      WsUrl: appConfig.WsUrl,
      GraphQlUrl: appConfig.GraphQlUrl
    },
    dependencies,
    gqTools: {
      getClient,
      gql
    },
    eds: {
      ApiUrl: appConfig.GraphQlUrl,
      UserId: () => auth.getUserData().id,
      Language: () => i18n.locale,
      Vuetify: vuetify,
      i18n: i18n,
      WorkerUrl: worker
    }
  })
  mergeLocalization(i18n, model.Modules.DefaultModuleImpl.Localization)
  store.commit('SET_LOCALIZATION', i18n.locale)

  Vue.use(jsActions, { dependencies })

  if (model.Settings.DisplayAppVersionChange) {
    let response = await appVersionsManager.getAndSetAppVersion(appName)
    appVersionsManager.subscribeToVerifyVersion(appName, response)
  }
  Vue.use(appEventHandlers, { dependencies })
}

function loadManifest(appName) {
  let basePath = process.env.VUE_APP_BASE_PATH
  if (!basePath.endsWith('/')) {
    basePath += '/'
  }

  let graphQlUrl = appConfig.GraphQlUrl
  if (!graphQlUrl.endsWith('/')) {
    graphQlUrl += '/'
  }

  let pathToApp = window.location.href
  let iconPath = basePath + '/it-icon.png'

  let str = `${graphQlUrl}applicationManifest?pathToApp=${encodeURIComponent(pathToApp)}&iconPath=${encodeURIComponent(iconPath)}&appName=${appName}`

  window.document.querySelector('#manifest-placeholder').setAttribute('href', str)
}

function Init(Vue, appRuntime, store, auth, router, model) {
  return new Promise((resolve) => {
    Vue.use(appRuntime, {
      store,
      auth,
      router,
      model,
      basePath,
      wsUrl,
      graphQlTools: { getClient }, // GraphQL Tools
      InitDataSources,
      installCallback() {
        authEventBus(Vue)
        return resolve()
      }
    })
  })
}

function authEventBus (Vue) {
  Vue.$authEventBus.onBeforeSignIn(() => {
    store.commit('CLEAR_ERROR')
  })
  Vue.$authEventBus.onAfterSignIn(() => {
    // выполняется только после логина
  })
  Vue.$authEventBus.onSignInError((message) => {
    notificationApi.showError({ text: message.errorMessage })
  })
  Vue.$authEventBus.onStartProcessing(() => {
    store.commit('SET_PROCESSING', true)
  })
  Vue.$authEventBus.onEndProcessing(() => {
    store.commit('SET_PROCESSING', false)
  })
  Vue.$authEventBus.onSignOut(() => {
    // apolloClientClearCache()
    Vue.$routerCore.GoToSignIn()
  })

  Vue.$authCore.SetAdditionalUserDataHandler(
    async () => {
      if (Vue.$authCore.userRole !== null) {
        return
      }
      Vue.$authCore.SetUserRole('User')
    }
  )
}

function getAppToDownload() {
  if (appConfig.application?.uniqID) {
    return {
      appName: appConfig.application.uniqID,
      isSystem: typeof appConfig.application.isSystem === 'boolean' ? appConfig.application.isSystem : appConfig.application.isSystem === 'true',
      basePath: '/'
    }
  }
  let params = router.history.getCurrentLocation().split('/')

  // По умолчанию системная модель
  let appName = ''

  // Если params[2] заполнен, тогда берем приложение из Url иначе назначаем приложение как не найденное
  if (params.length > 2 && params[2]) {
    appName = params[2]
  } else {
    appName = 'AppNotFound'
  }

  let basePath = `/s/${appName}`
  let isSystem = true

  let roleSegment = params[1].toLowerCase()

  // Берем системную модель, если путь указан http://m.it.ua/webaaps/v/TestApp => http://m.it.ua/webaaps/v/s/TestApp
  if (roleSegment != 's' && roleSegment != 'u') {
    appName = params[1]
    basePath = `/s/${appName}`
  }
  // Пользовательская модель
  if (roleSegment == 'u') {
    basePath = `/u/${appName}`
    isSystem = false
  }
  window.appPath = basePath
  return {
    appName: appName,
    basePath: basePath,
    isSystem: isSystem
  }
}

function mergeLocalization(i18n, localization) {
  const keys = Object.keys(localization)

  // если обьект представляет собой старую версию локализации
  if (keys.length === 3 && keys.includes('ru') && keys.includes('en') && keys.includes('uk')) {
    i18n.mergeLocaleMessage('ru', localization['ru'])
    i18n.mergeLocaleMessage('en', localization['en'])
    i18n.mergeLocaleMessage('uk', localization['uk'])
    return
  }

  i18n.mergeLocaleMessage(i18n.locale, localization)
}

export default registerAppRuntime